import { Center, Flex } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { closeChannelOverlay } from 'pages/Conversations/state/conversationsSlice';
import React from 'react';
import { useAppDispatch } from 'state/hooks';
import { ReactComponent as EmptyStateIllustration } from 'pages/Conversations/assets/channel-view-empty-state.svg';
import { Text } from '@televet/kibble-ui/build/components/Text';

export const NoChannelFound = (): JSX.Element => {
  const dispatch = useAppDispatch();
  return (
    <>
      <Flex align="center" justify="flex-end" overflowX="auto" py={2} pl={2}>
        <Flex align="center" pr={2} bgColor="background.default">
          <Button
            data-testid="convo-close-button"
            iconName="close"
            variant="ghostNeutral"
            onClick={(): void => {
              dispatch(closeChannelOverlay());
            }} />
        </Flex>
      </Flex>
      <Center height="100%" flexDirection="column">
        <EmptyStateIllustration />
        <Text variant="subtle">No conversation found.</Text>
      </Center>
    </>
  );
};
